var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _radialGradient, _radialGradient2, _linearGradient12, _linearGradient13, _linearGradient14, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChairWhite = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 311.86 450.27",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a4a26413-1425-4746-ba23-3053fd188901"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.55,447.47c-2.66,0-36-76.58-62.54-138.71q-1.31-3-2.58-6c-4.18-9.79-8.16-19.12-11.78-27.64l-1.71-4c-3.32-7.83-6.31-14.87-8.81-20.8h0c2.46,5.83,5.39,12.73,8.64,20.4q6.85-1.71,13.36-3.71c24.71,64.4,68.33,179.21,65.6,180.45l-.14.06h0",
    style: {
      fill: "none"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11",
    "data-name": "Sfumatura senza nome 11",
    x1: -731.03,
    y1: 652.45,
    x2: -727.27,
    y2: 652.45,
    gradientTransform: "translate(37420.9 41859.54) rotate(90) scale(56.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a97551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d78b45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d78b45"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "5ad672d0-3a21-44ed-93a8-23b206d2c3a1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.77,270.66c-3.25-7.67-6.18-14.57-8.64-20.4,4.88-.6,9.83-1.3,14.78-2.09,1.87,4.87,4,10.37,6.27,16.32a.49.49,0,0,1,0,.11c.3.78.6,1.56.91,2.35q-6.51,2-13.36,3.71",
    style: {
      fill: "none"
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12",
    "data-name": "Sfumatura senza nome 12",
    x1: -731.03,
    y1: 653.03,
    x2: -727.27,
    y2: 653.03,
    gradientTransform: "translate(37420.9 41859.54) rotate(90) scale(56.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#884836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac5631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac5631"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "5b335c70-6c1f-4900-af68-227cc9ed9df9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.29,450.27h0l-.15,0c-2.38-.44,8-81.51,17-148.68l11,6.9C129.63,374,115.68,450.27,113.29,450.27M142,303.7l-11.21-7q.54-4.05,1.08-8l13.82-6.11c-1.18,6.79-2.42,13.87-3.69,21.11m-9.43-20.21c1.72-12.66,3.33-24.43,4.73-34.58h0c-1.24,9-2.65,19.27-4.15,30.3q4.07.26,8.19.4l-8.77,3.88m14.36-8.06a.43.43,0,0,0,0-.11.43.43,0,0,1,0,.11M147,275l.06-.36c0,.11,0,.24-.06.36m.07-.42.06-.34-.06.34m.07-.4c1.5-8.61,2.89-16.65,4.12-23.83h0c-1.23,7.19-2.62,15.22-4.12,23.83",
    style: {
      fill: "none"
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-2",
    x1: -729.66,
    y1: 682.01,
    x2: -725.9,
    y2: 682.01,
    gradientTransform: "matrix(5.64, 56.75, 56.75, -5.64, -34470.81, 45491.43)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fb1ac95f-fc26-43f0-b4cb-7fcc139e0c97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.35,279.61q-4.12-.15-8.19-.4c1.5-11,2.91-21.3,4.15-30.3q7,.78,14,1.4c-1.23,7.18-2.62,15.22-4.12,23.83,0,0,0,0,0,.06l-.06.34s0,0,0,.06L147,275c0,.12,0,.24-.07.36a.43.43,0,0,1,0,.11c-.1.62-.21,1.23-.32,1.85l-5.27,2.33",
    style: {
      fill: "none"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12-2",
    x1: -729.66,
    y1: 682.34,
    x2: -725.9,
    y2: 682.34,
    gradientTransform: "matrix(5.64, 56.75, 56.75, -5.64, -34470.81, 45491.43)",
    xlinkHref: "#Sfumatura_senza_nome_12"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-3",
    x1: -2.9,
    y1: 344.78,
    x2: 90.75,
    y2: 344.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-4",
    x1: 74.6,
    y1: 243.75,
    x2: 74.7,
    y2: 243.75,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-5",
    x1: 74.71,
    y1: 243.46,
    x2: 74.82,
    y2: 243.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-6",
    x1: -730.91,
    y1: 682.42,
    x2: -730.84,
    y2: 682.42,
    gradientTransform: "matrix(0, 56.94, 56.94, 0, -38783.6, 41859.54)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "08c4d35b-6ba8-4684-bd53-dda34d7ed93c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.83,271.24c-4.56-1.1-9-2.29-13.38-3.57,3.48-9.06,6.59-17.14,9.16-23.8l.09-.25v0c0-.09.07-.18.11-.26a.88.88,0,0,1,.05-.15l1.6-4.14c4.89,1.19,9.84,2.17,14.71,3-3,7.15-7.28,17.25-12.35,29.16",
    style: {
      fill: "none"
    }
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12-3",
    x1: -731.03,
    y1: 682.47,
    x2: -727.27,
    y2: 682.47,
    gradientTransform: "matrix(0, 56.94, 56.94, 0, -38783.6, 41859.54)",
    xlinkHref: "#Sfumatura_senza_nome_12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b9df833-ed14-427d-b996-26342aa24f7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.57,450.27c-2.14,0-13.56-61.22-24.21-121l-1.05-6c-3-17.14-6-34-8.62-49.09-.26-1.53-.53-3.06-.79-4.55-1.14-6.62-2.22-12.84-3.2-18.54h0c1.46,8.51,3.14,18.19,5,28.59q6.57-.21,13-.65c-1.32-9.69-2.56-18.78-3.68-26.93h0c.79,5.8,1.65,12.06,2.55,18.68.24,1.7.47,3.43.71,5.18,1.85,13.57,3.85,28.4,5.86,43.51.22,1.68.44,3.36.67,5,8.12,61.35,16.07,125.33,14,125.72l-.15,0h0",
    style: {
      fill: "none"
    }
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_11-7",
    x1: -732.56,
    y1: 652.79,
    x2: -728.81,
    y2: 652.79,
    gradientTransform: "translate(33108.1 45491.43) rotate(95.68) scale(57.03)",
    xlinkHref: "#Sfumatura_senza_nome_11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3796433f-9e03-4292-a481-4057d91e28d2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.65,279.69c-1.81-10.4-3.49-20.08-5-28.59q7.14.56,14.29,1c1.12,8.15,2.36,17.24,3.68,26.93q-6.45.43-13,.65",
    style: {
      fill: "none"
    }
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_12-4",
    x1: -732.56,
    y1: 653.12,
    x2: -728.81,
    y2: 653.12,
    gradientTransform: "translate(33108.1 45491.43) rotate(95.68) scale(57.03)",
    xlinkHref: "#Sfumatura_senza_nome_12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "571cf90c-8e76-4a94-ae17-18abe7368f81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.83,182.94a97.83,97.83,0,0,1-50.71-48.15c-20.48-43.21-61.75-125.14-85-131.55C81.27-5,32.3,3.69,25.12,16.29c-7.35,12.86,5.75,92.6-4.81,148.22C8.77,225.39,144.24,234,180.12,242.05c36.55,8.2,136-6.15,127.08-24.54-8.19-16.83-35.06-24.34-60.37-34.57",
    style: {
      fill: "none"
    }
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_14",
    "data-name": "Sfumatura senza nome 14",
    cx: -725.95,
    cy: 662.95,
    r: 3.76,
    gradientTransform: "matrix(65.64, 0, 0, -65.64, 47797.76, 43674.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d5d4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ba5f0b2-11b1-4a2b-8a37-7d1b0f82f31e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.88,244.41c-10.83,0-20.53-.73-27.76-2.36h0c1,.22,2,.43,3.1.62l.17,0,.94.16.3,0h0c1.5.23,3.07.44,4.71.62a174.6,174.6,0,0,0,18.52.88h0m-27.76-2.36-.1,0h0l.1,0h0m-.11,0-.1,0h0l.08,0h0m-.1,0-.1,0a0,0,0,0,1,0,0h.09m-.11,0C157.37,237,97.59,231.81,57.74,214.3c21.43,9.41,48.63,15.28,72.68,19.45h0l.2,0h0l1,.18h0l.15,0h.05l.16,0h0l.41.07h0l.19,0h0l.2,0h0l.16,0,.09,0h0l.38.07.14,0,.16,0h0l.14,0h.06l.12,0,.12,0h.05l.13,0h.1c18.63,3.14,35,5.31,44.68,7.41h0l.22,0h0l.1,0h0l.09,0h0m-4.67-21.32a899.84,899.84,0,0,1-95.65-5.29c-22.26-7.16-41.54-17-50.6-31a38.32,38.32,0,0,1-5.35-21.51v0a38.78,38.78,0,0,1,.56-4C34.12,106,22.8,31.38,28,13.07a12.25,12.25,0,0,0-2.84,3.22c-7.35,12.87,5.75,92.6-4.81,148.22-.16.9-.3,1.78-.41,2.65.11-.87.25-1.75.41-2.65,10.56-55.62-2.54-135.36,4.81-148.22C30.35,7.11,57.73,0,83.77,0a105.05,105.05,0,0,1,27.39,3.24c23.21,6.42,64.48,88.34,85,131.55a97.83,97.83,0,0,0,50.71,48.15C269.3,192,293,199,303.77,212.18c-3.92-4.8-9.53-8.78-16.18-12.32,0,0,3.35,7.89-53,17.52-10,1.71-31.13,3.28-59.48,3.28m132-3.25v0s0,0,0,0m0-.09,0,0s0,0,0,0m-.05-.09s0,0,0,0,0,0,0,0m-.05-.1,0,0,0,0M307,217s0,0,0,0,0,0,0,0m0-.11h0m-.11-.2v0m-.05-.09v0m-.05-.09s0,0,0,0,0,0,0,0m-.05-.1v0m0-.1h0m-.12-.2h0m-.05-.09v0m-.05-.09a0,0,0,0,1,0,0v0m-.05-.1,0,0,0,0m-.06-.09s0,0,0,0,0,0,0,0m-.06-.1h0m-.11-.2h0m-.06-.09v0m-.05-.09,0,0,0,0m-.06-.09v0m-.06-.09v0m-.18-.29h0m-.05-.09,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-.06-.09,0,0,0,0m-.07-.11h0M57.73,214.3l-.15-.07.15.07m247.6,0,0,0,0,0m-247.77-.06-.15-.06.15.06m247.71,0,0,0,0,0m-247.87,0-.15-.07.15.07m247.81,0,0,0,0,0m-248,0-.62-.28.62.28M305.15,214l0,0,0,0m-.06-.09,0,0,0,0m-.06-.09,0,0,0,0m-248.44-.06-.14-.06.14.06m248.36,0s0,0,0,0,0,0,0,0m-248.53,0-.14-.06.14.06m248.47-.07,0,0,0,0m-248.63,0-.14-.07.14.07m-.15-.07-.47-.21.47.21m248.71,0,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-249.07,0-.13-.06.13.06m249,0,0-.05,0,.05m-249.18,0-.11-.05.11.05m249.12,0-.14-.19.14.19m-249.3,0-.11-.05.11.05m-.16-.07-.12-.06.12.06M55,213l-.39-.18L55,213m249.47,0,0-.05,0,.05m-.06-.08-.05-.05.05.05m-.07-.08,0-.06,0,.06m-249.79,0-.09,0,.09,0m249.73-.05,0-.06,0,.06m-249.9,0-.1,0,.1,0m249.84,0c-.09-.13-.19-.25-.28-.37.09.12.19.24.28.37m-250,0-.08,0,.08,0m-.17-.08-.09,0,.09,0m-.18-.09-.07,0,.07,0m-.23-.11-.08,0,.08,0m250.31-.06-.06-.06.06.06m-250.49,0-.07,0,.07,0m250.43-.05-.06-.07.06.07m-250.6,0-.07,0,.07,0m-.17-.08-.08,0,.08,0m-.18-.09-.06,0,.06,0m-.19-.09,0,0,0,0m-.39-.19,0,0a.05.05,0,0,1,0,0m-.16-.09-.06,0,.06,0M52,211.6l-.05,0,.05,0m-.17-.09,0,0,0,0m-.2-.1h0m-.36-.18,0,0,0,0m-.17-.08-.05,0,.05,0m-.17-.09,0,0,0,0m-.19-.1h0m-.19-.09h0m-.35-.19h0M50,210.6l0,0,0,0m-.17-.09,0,0,0,0m-.19-.1h0m-.7-.37h0m-.17-.09h0m-1-.57h0m-24.2-22a32.63,32.63,0,0,1-3.9-14.83c0-.25,0-.5,0-.75a32.87,32.87,0,0,0,3.91,15.58h0",
    style: {
      fill: "none"
    }
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_14-2",
    cx: -719.16,
    cy: 660.67,
    r: 3.76,
    gradientTransform: "matrix(43.63, 0, 0, -43.63, 31547.9, 28948.37)",
    xlinkHref: "#Sfumatura_senza_nome_14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "649b76a0-2901-4f83-9cb2-3869765e4cc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.72,226.78h0c3.22-2.19,5-4.51,5-6.92a5.06,5.06,0,0,0-.41-2c1.3,3.13-.53,6.14-4.63,8.93",
    style: {
      fill: "none"
    }
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_17",
    "data-name": "Sfumatura senza nome 17",
    x1: -726.2,
    y1: 703.53,
    x2: -722.44,
    y2: 703.53,
    gradientTransform: "matrix(-0.28, 28.17, 28.17, 0.28, -19713.74, 20396.87)",
    xlinkHref: "#Sfumatura_senza_nome_14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "45c5051b-2dca-44b1-b5bf-6675dccc8aae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.88,244.41h0c34.23,0,79.81-7.38,94.84-17.63h0c-15,10.25-60.61,17.63-94.84,17.63",
    style: {
      fill: "none"
    }
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_16",
    "data-name": "Sfumatura senza nome 16",
    x1: -726.2,
    y1: 701.76,
    x2: -722.44,
    y2: 701.76,
    gradientTransform: "matrix(-0.28, 28.17, 28.17, 0.28, -19713.74, 20396.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbbab6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a19a9d"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "077d00bc-de9f-4b2a-87c8-25f519663230"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.2,217.51s0-.07-.05-.1a.93.93,0,0,1,.05.1m-.06-.12,0-.07,0,.07m-.05-.1,0-.06,0,.06m0-.1,0-.06,0,.06m-.05-.09,0-.06,0,.06m0-.09a.3.3,0,0,1,0-.08.3.3,0,0,0,0,.08m-.05-.09a1.74,1.74,0,0,0-.1-.19,1.14,1.14,0,0,1,.1.19m-.11-.21,0-.07,0,.07m-.05-.1,0-.06a.21.21,0,0,1,0,.06m-.05-.09a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.05-.09a.3.3,0,0,1,0-.08.3.3,0,0,0,0,.08m-.05-.09-.11-.2.11.2m-.11-.2a.41.41,0,0,0-.05-.09.41.41,0,0,1,.05.09m-.06-.11a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.05-.09a.25.25,0,0,1,0-.07.25.25,0,0,0,0,.07m-.06-.09a.25.25,0,0,0,0-.07.16.16,0,0,1,0,.07m-.05-.09a.22.22,0,0,0-.05-.08.22.22,0,0,1,.05.08m-.05-.09-.11-.19.11.19m-.12-.19a.41.41,0,0,0,0-.09.41.41,0,0,1,0,.09m-.06-.11a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.06-.09,0-.07,0,.07m-.05-.09-.05-.07.05.07m-.06-.09c-.05-.09-.11-.18-.17-.27.06.09.12.18.17.27m-.18-.28,0-.08,0,.08m-.06-.1,0-.06,0,.06m-.06-.09,0-.06,0,.06m-.06-.09,0-.06,0,.06m-.06-.09-.05-.08.05.08m-.05-.08a.47.47,0,0,1-.06-.09l.06.09m-.08-.11,0-.07,0,.07m-.06-.1,0,0,0,0m-.07-.09,0,0,0,0m-.06-.08,0-.06,0,.06m-.05-.09,0-.06,0,.06m-.07-.09-.05-.07.05.07m-.07-.1a.43.43,0,0,1,0-.07l0,.07m-.07-.1a.1.1,0,0,0,0-.05.1.1,0,0,1,0,.05m-.06-.09a.08.08,0,0,0,0,0,.08.08,0,0,1,0,0m-.07-.09,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-.17-.22v0m-.05-.07,0,0,0,0m-.07-.08,0,0,0,0m-.06-.09,0,0,0,0m-.06-.08h0m-.3-.38h0m-.07-.07h0m-.06-.08h0",
    style: {
      fill: "none"
    }
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_17-2",
    "data-name": "Sfumatura senza nome 17",
    x1: -726.2,
    y1: 703.54,
    x2: -722.44,
    y2: 703.54,
    gradientTransform: "matrix(-0.28, 28.17, 28.17, 0.28, -19713.74, 20396.87)",
    xlinkHref: "#Sfumatura_senza_nome_14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5446b539-a70b-44b1-a077-c51ae3027d06"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.88,244.41a174.6,174.6,0,0,1-18.52-.88,174.6,174.6,0,0,0,18.52.88c41.19,0,98.83-10.69,99.86-24.2-9.25,7.3-34.14,13.26-60.2,16.32h0c-9.79,1-21.38,1.39-32,1.39-15.08,0-28.24-.76-31.66-1.53h0l-.1,0h0l-.09,0h-.13l-.42-.09h0c-19.5-4.22-65.88-8.7-103.66-20.86a899.84,899.84,0,0,0,95.65,5.29c28.35,0,49.45-1.57,59.48-3.28,56.33-9.63,53-17.53,53-17.53,6.65,3.55,12.26,7.53,16.18,12.33h0l.06.08h0l.06.06h0c.09.12.19.24.28.37h0l0,.06,0,0,0,.06,0,0,.05.05,0,0,0,.05v0l.14.19,0,0,0,.05,0,0,0,0,0,0,0,0s0,0,0,0l0,0a.1.1,0,0,1,0,.05l0,0a.43.43,0,0,0,0,.07s0,0,0,0l.05.07,0,0,0,.06,0,0,0,.06,0,0,0,0,0,0,0,0,0,0,0,.07,0,0a.47.47,0,0,0,.06.09h0l.05.08,0,0,0,.06,0,0,0,.06,0,0,0,.06,0,0,0,.08h0c.06.09.12.18.17.27v0l.05.07v0l0,.07,0,0a.43.43,0,0,0,0,.07v0a.41.41,0,0,1,0,.09h0l.11.19h0a.22.22,0,0,1,.05.08s0,0,0,0a.25.25,0,0,1,0,.07l0,0a.25.25,0,0,0,0,.07s0,0,0,0a.59.59,0,0,0,0,.08v0a.41.41,0,0,1,.05.09h0l.11.19h0a.3.3,0,0,0,0,.08v0a.43.43,0,0,0,0,.07s0,0,0,0l0,.06v0l0,.07v0l.1.19h0a.3.3,0,0,0,0,.08s0,0,0,0l0,.06,0,0,0,.06s0,0,0,0l0,.06,0,0,0,.07v0s0,.07.05.1h0c.05.11.11.23.15.34a5.06,5.06,0,0,1,.41,2c0,2.41-1.82,4.73-5,6.92-15,10.25-60.61,17.63-94.84,17.63m-23.23-1.5h0m-.32,0-.94-.16.94.16m-1.11-.19c-1.08-.19-2.11-.4-3.1-.62h0c1,.22,2,.43,3.1.62",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "617010c8-b191-41be-876c-fdd68b6b479d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.88,244.41a174.6,174.6,0,0,1-18.52-.88c-1.64-.18-3.21-.39-4.71-.62h0l-.3-.06-.94-.15-.17,0c-1.08-.19-2.11-.4-3.1-.62a39,39,0,0,0,7.91.59c19.41,0,58.93-6,59.51-6.11,26.06-3.06,51-9,60.2-16.32-1,13.51-58.67,24.2-99.86,24.2m-27.76-2.36-.1,0,.1,0m-.12,0-.08,0,.08,0m-.11,0h0m-.1,0-.09,0,.09,0m-.1,0-.1,0,.1,0m-.1,0-.22,0,.22,0m-.22,0c-9.71-2.1-26.05-4.27-44.68-7.41,18.64,3.15,35,5.31,44.68,7.41m4.42-5.52h0m-.1,0h0m-.1,0h0m-.45-.1h0m-48.45-1.75h0m-.23,0h0m-.17,0-.12,0,.12,0m-.18,0-.14,0,.14,0m-.16,0-.16,0,.16,0m-.3-.05-.38-.07.38.07m-.42-.07-.09,0,.09,0m-.25-.05h0m-.22,0h0m-.19,0h0m-.44-.07h0m-.2,0h0m-.2,0h0m-1.09-.19h0m-.21,0h0M23.53,187.33a32.9,32.9,0,0,1-3.91-15.58,38.21,38.21,0,0,1,.28-4.6c.11-.86.25-1.74.41-2.64,10.56-55.62-2.54-135.35,4.81-148.22A12.25,12.25,0,0,1,28,13.07C22.8,31.38,34.12,106,24.09,158.86a38.78,38.78,0,0,0-.56,4c-.15.77-3.44,17.89,0,24.45",
    style: {
      fill: "none"
    }
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_18",
    "data-name": "Sfumatura senza nome 18",
    cx: -707.44,
    cy: 652.19,
    r: 3.76,
    gradientTransform: "matrix(25.7, 0, 0, -25.7, 18284.16, 16983.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d5d4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5c491f9-cf4a-408e-9240-ab953658a9de"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "180.02 242.03 180.01 242.03 180.02 242.03",
    style: {
      fill: "none"
    }
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_22",
    "data-name": "Sfumatura senza nome 22",
    cx: -706.21,
    cy: 652.29,
    r: 0,
    gradientTransform: "matrix(26.99, 0, 0, -26.99, 19240.5, 17847.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f5f4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b6f44e8-4a03-4dc1-8d44-baf37062dce8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,242h0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "74d85733-2520-4d24-a02b-5243ac2386c4"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "179.91 242.01 179.91 242 179.91 242.01",
    style: {
      fill: "none"
    }
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_22-2",
    cx: -706.21,
    cy: 652.29,
    r: 0,
    xlinkHref: "#Sfumatura_senza_nome_22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0a711051-4055-4cb3-a148-188fc1990fc6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.92,242h0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d1c9e35-9d9b-4f0e-b749-d6f84f53eb3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.81,242h0",
    style: {
      fill: "none"
    }
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_22-3",
    cx: -706.21,
    cy: 652.29,
    r: 0,
    xlinkHref: "#Sfumatura_senza_nome_22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d0be26d1-5d9e-41dd-8899-d751a1589a47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.82,242a0,0,0,0,0,0,0h0m-.12,0h0m-.11,0h0m-.22-.05h0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b4db415-1330-4f42-b1f6-2e3079377095"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.65,238.75c-10.83,0-20.52-.73-27.76-2.36,3.42.77,16.58,1.53,31.66,1.53,10.62,0,22.21-.38,32-1.39h0a315.31,315.31,0,0,1-35.89,2.22m-27.76-2.36-.1,0,.1,0m-.11,0-.09,0,.09,0m-.11,0h0m-.11,0-.42-.09.42.09",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e8340d4-a1a6-4709-b357-52b569c774e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.48,215.37h0C47.25,205,21.26,189,23.53,162.88v0a38.32,38.32,0,0,0,5.35,21.51c9.06,14,28.34,23.85,50.6,31",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dde2283-33c6-4d05-b3a3-b000263f2122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.14,236.23c-19.5-4.22-65.87-8.7-103.66-20.86h0c37.78,12.16,84.16,16.64,103.66,20.86",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e67c3f3-8822-414f-b7cb-59b49f30e3be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.69,234.48h0m-.1,0-.13,0,.13,0m-.18,0-.12,0,.12,0m-.24,0h0m-.2,0h0m-.18,0-.14,0,.14,0m-.52-.09h0m-.13,0-.16,0,.16,0m-.18,0-.2,0,.2,0m-.2,0-.19,0,.19,0m-.22,0-.41-.07.41.07m-.45-.08-.16,0,.16,0m-.21,0-.15,0,.15,0m-.2,0-1-.18,1,.18m-1.05-.18-.2,0,.2,0",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "69366834-845d-4fe6-b9ed-96b55a50d0c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.74,214.3h0m-.16-.07h0m-.17-.08h0m-.16-.07h0m-.63-.28,0,0,0,0m-.17-.08h0m-.17-.07h0s0,0,0,0m-.16-.08h0m-.48-.21h0a0,0,0,0,1,0,0m-.14-.07,0,0,0,0m-.15-.07-.07,0,.07,0m-.18-.08-.05,0,.05,0m-.17-.08,0,0,0,0m-.43-.2-.06,0,.06,0m-.15-.07-.08,0,.08,0m-.18-.08-.08,0,.08,0m-.16-.08-.09,0,.09,0m-.18-.08-.09-.05.09.05m-.16-.08-.16-.08.16.08m-.24-.12-.1,0,.1,0m-.17-.08-.1-.05.1.05m-.17-.08-.1-.05.1.05M53,212.1l-.1,0,.1,0m-.16-.08-.13-.06.13.06m-.17-.08-.35-.17.35.17m-.39-.19-.12-.07.12.07m-.18-.09L52,211.6l.12.06m-.17-.09-.12-.06.12.06m-.17-.08-.15-.08.15.08m-.17-.09-.34-.17.34.17m-.38-.19-.13-.06.13.06m-.18-.09-.12-.06.12.06m-.17-.08L50.7,211l.14.08m-.16-.09-.17-.08.17.08m-.17-.09-.35-.18.35.18m-.36-.18L50,210.6l.16.08m-.18-.1-.15-.07.15.07m-.18-.09-.16-.08.16.08m-.17-.08-.69-.37.69.37m-.7-.38-.16-.08.16.08m-.17-.09-1-.56,1,.56m-1-.56c-10.89-6-19.48-13.22-24.17-22l0,0c4.68,8.81,13.28,16,24.19,22",
    style: {
      fill: "none"
    }
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_22-4",
    cx: -708.74,
    cy: 652.99,
    r: 3.76,
    xlinkHref: "#Sfumatura_senza_nome_22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "910ba1d9-209e-406f-8a07-d7375f59494f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.42,233.75c-24-4.17-51.25-10-72.68-19.45h0l-.15-.07h0l-.15-.07h0l-.15-.07h0l-.62-.28,0,0-.14-.06h0l-.14-.06s0,0,0,0l-.14-.07h0l-.47-.21a0,0,0,0,0,0,0l-.13-.06,0,0-.11-.05-.07,0-.11-.05-.05,0-.12-.06,0,0-.39-.18-.06,0-.09,0-.08,0-.1,0-.08,0-.08,0-.09,0-.09,0-.09-.05-.07,0-.16-.07-.08,0-.1,0-.07,0-.1,0-.07,0-.1-.05-.08,0-.1,0-.06,0-.13-.06,0,0-.35-.17a.05.05,0,0,0,0,0l-.12-.07-.06,0L52,211.6l-.05,0-.12-.06,0,0-.15-.08h0l-.34-.17,0,0-.13-.06-.05,0-.12-.06,0,0L50.7,211h0l-.17-.08h0l-.35-.18h0L50,210.6l0,0-.15-.07,0,0-.16-.08h0l-.69-.37h0l-.16-.08h0l-1-.56h0c-10.91-6-19.51-13.24-24.19-22h0c14.33,26.95,65.31,39.2,106.89,46.42",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f125bffc-9fb8-4b8d-99ef-cf1e5a164dd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188,242.64a39,39,0,0,1-7.91-.59h0l-.1,0h0l-.08,0h-.13l-.09,0h0l-.1,0h0l-.22,0h0c-9.71-2.1-26-4.26-44.68-7.41h-.1l-.13,0h-.05l-.12,0-.12,0h-.06l-.14,0h0l-.16,0-.14,0-.38-.07h0l-.09,0-.16,0h0l-.2,0h0l-.19,0h0l-.41-.07h0l-.16,0h-.05l-.15,0h0l-1-.18h0l-.2,0h0c-41.58-7.22-92.56-19.48-106.89-46.42-3.44-6.56-.15-23.68,0-24.45C21.26,189,47.25,205,79.48,215.37c37.79,12.16,84.16,16.64,103.66,20.86h0l.42.09h.13l.09,0h0l.1,0h0c7.24,1.63,16.93,2.36,27.76,2.36a315.31,315.31,0,0,0,35.89-2.22c-.58.09-40.1,6.11-59.51,6.11",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a5d47298-7128-40e0-8af6-19af1d179bfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.2,217.51c-8.19-16.83-35.06-24.34-60.37-34.58a97.72,97.72,0,0,1-50.7-48.14c-20.49-43.21-61.76-125.14-85-131.55-22-6.07-54.18-3-72.6,4.08C57.4,1.89,85,0,104.56,5.44c23.21,6.42,64.48,88.34,85,131.55a97.72,97.72,0,0,0,50.7,48.14c25.31,10.24,52.18,17.75,60.37,34.58,2.57,5.28-2.35,16.56-84.62,24.7C308.86,242.63,310.23,223.75,307.2,217.51Z",
    style: {
      fill: "none"
    }
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Sfumatura_senza_nome_23",
    "data-name": "Sfumatura senza nome 23",
    cx: -716.85,
    cy: 660.03,
    r: 3.76,
    gradientTransform: "matrix(39.43, 0, 0, -39.43, 28447.54, 26135.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e0e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#d4d6d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d6d3"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAACXBIWXMAAAROAAAETgFCi5P8AAAAFUlEQVQIW2P8////fwYoYGJAAigcAJIKBAJOtx2SAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M243.25,260.85l-63.19,62.64c.14,1.78.25,3.57.36,5.36l64.81-64.26c-.59-1.23-1.26-2.48-2-3.74",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    d: "M257.46,307.83,171.94,268.2c.37,1.75.71,3.53,1,5.31l86.1,39.91q-.81-2.79-1.6-5.59",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g140"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a4a26413-1425-4746-ba23-3053fd188901)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M311.55,447.47c-2.66,0-36-76.58-62.54-138.71q-1.31-3-2.58-6c-4.18-9.79-8.16-19.12-11.78-27.64l-1.71-4c-3.32-7.83-6.31-14.87-8.81-20.8h0c2.46,5.83,5.39,12.73,8.64,20.4q6.85-1.71,13.36-3.71c24.71,64.4,68.33,179.21,65.6,180.45l-.14.06h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_11)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M246.13,267c-.31-.79-.61-1.57-.91-2.35h0c.3.78.6,1.56.91,2.35h0m-.95-2.46h0c-2.28-5.95-4.4-11.45-6.27-16.32h0c1.88,4.87,4,10.36,6.27,16.32",
    style: {
      fill: "#c69293"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M245.22,264.6a.49.49,0,0,0,0-.11h0a.49.49,0,0,1,0,.11h0",
    style: {
      fill: "#251d1d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g162"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#5ad672d0-3a21-44ed-93a8-23b206d2c3a1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M232.77,270.66c-3.25-7.67-6.18-14.57-8.64-20.4,4.88-.6,9.83-1.3,14.78-2.09,1.87,4.87,4,10.37,6.27,16.32a.49.49,0,0,1,0,.11c.3.78.6,1.56.91,2.35q-6.51,2-13.36,3.71",
    style: {
      fill: "url(#Sfumatura_senza_nome_12)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g180"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#5b335c70-6c1f-4900-af68-227cc9ed9df9)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M113.29,450.27h0l-.15,0c-2.38-.44,8-81.51,17-148.68l11,6.9C129.63,374,115.68,450.27,113.29,450.27M142,303.7l-11.21-7q.54-4.05,1.08-8l13.82-6.11c-1.18,6.79-2.42,13.87-3.69,21.11m-9.43-20.21c1.72-12.66,3.33-24.43,4.73-34.58h0c-1.24,9-2.65,19.27-4.15,30.3q4.07.26,8.19.4l-8.77,3.88m14.36-8.06a.43.43,0,0,0,0-.11.43.43,0,0,1,0,.11M147,275l.06-.36c0,.11,0,.24-.06.36m.07-.42.06-.34-.06.34m.07-.4c1.5-8.61,2.89-16.65,4.12-23.83h0c-1.23,7.19-2.62,15.22-4.12,23.83",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-2)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M146.62,277.28c.11-.62.22-1.23.32-1.85-.1.62-.21,1.23-.32,1.85h0m.34-2c0-.12,0-.24.07-.36,0,.12,0,.24-.07.36m.13-.72s0,0,0-.06,0,0,0,.06m.07-.4s0,0,0-.06,0,0,0,.06",
    style: {
      fill: "#c69293"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g200"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fb1ac95f-fc26-43f0-b4cb-7fcc139e0c97)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M141.35,279.61q-4.12-.15-8.19-.4c1.5-11,2.91-21.3,4.15-30.3q7,.78,14,1.4c-1.23,7.18-2.62,15.22-4.12,23.83,0,0,0,0,0,.06l-.06.34s0,0,0,.06L147,275c0,.12,0,.24-.07.36a.43.43,0,0,1,0,.11c-.1.62-.21,1.23-.32,1.85l-5.27,2.33",
    style: {
      fill: "url(#Sfumatura_senza_nome_12-2)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M52,319.13l118.3-52.3,1.62,4.18-118.3,52.3L52,319.13",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M183.41,329.61,73.76,261l-2.2,3.9,109.65,68.61,2.2-3.9",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.12,447.4c-2.72-1.23,40.57-115.22,65.33-179.73,4.35,1.28,8.82,2.47,13.38,3.57,5.07-11.91,9.34-22,12.35-29.16h0c-2.54,6-6,14.08-10,23.58l-1.77,4.17C73.75,283.22,67,299,59.91,315.62c-.86,2-1.73,4-2.59,6C31.86,381,2.79,447.47.31,447.47",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,243.87l.09-.25-.09.25",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,243.59c0-.09.07-.18.11-.26,0,.08-.07.17-.11.26",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,243.18l1.6-4.14h0l-1.6,4.14",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.12,447.4c-2.72-1.23,40.57-115.22,65.33-179.73,4.35,1.28,8.82,2.47,13.38,3.57,5.07-11.91,9.34-22,12.35-29.16h0c-2.54,6-6,14.08-10,23.58l-1.77,4.17C73.75,283.22,67,299,59.91,315.62c-.86,2-1.73,4-2.59,6C31.86,381,2.79,447.47.31,447.47",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,243.87l.09-.25-.09.25",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.71,243.59c0-.09.07-.18.11-.26,0,.08-.07.17-.11.26",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,243.18l1.6-4.14h0l-1.6,4.14",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M65.45,267.67h0c3.48-9.06,6.59-17.14,9.16-23.8-2.57,6.66-5.68,14.74-9.16,23.8m9.25-24.05v0m.12-.29c0-.05,0-.1.05-.15a.88.88,0,0,0-.05.15",
    style: {
      fill: "#c69293"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g242"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#08c4d35b-6ba8-4684-bd53-dda34d7ed93c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M78.83,271.24c-4.56-1.1-9-2.29-13.38-3.57,3.48-9.06,6.59-17.14,9.16-23.8l.09-.25v0c0-.09.07-.18.11-.26a.88.88,0,0,1,.05-.15l1.6-4.14c4.89,1.19,9.84,2.17,14.71,3-3,7.15-7.28,17.25-12.35,29.16",
    style: {
      fill: "url(#Sfumatura_senza_nome_12-3)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g260"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#4b9df833-ed14-427d-b996-26342aa24f7a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M198.57,450.27c-2.14,0-13.56-61.22-24.21-121l-1.05-6c-3-17.14-6-34-8.62-49.09-.26-1.53-.53-3.06-.79-4.55-1.14-6.62-2.22-12.84-3.2-18.54h0c1.46,8.51,3.14,18.19,5,28.59q6.57-.21,13-.65c-1.32-9.69-2.56-18.78-3.68-26.93h0c.79,5.8,1.65,12.06,2.55,18.68.24,1.7.47,3.43.71,5.18,1.85,13.57,3.85,28.4,5.86,43.51.22,1.68.44,3.36.67,5,8.12,61.35,16.07,125.33,14,125.72l-.15,0h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_11-7)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g278"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#3796433f-9e03-4292-a481-4057d91e28d2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M165.65,279.69c-1.81-10.4-3.49-20.08-5-28.59q7.14.56,14.29,1c1.12,8.15,2.36,17.24,3.68,26.93q-6.45.43-13,.65",
    style: {
      fill: "url(#Sfumatura_senza_nome_12-4)"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    d: "M247.41,193.5a88.9,88.9,0,0,1-41.53-32.42H23.4c-5,6.95-4.27,15.89-2.48,23.25,2.86,11.75,10.14,31,19.81,38.9,18,14.73,46.87,18.27,69.11,21.94,23.9,4,48,5.94,72.22,7.38,36.06,2.16,129.17-13.75,121-30.68-7.49-15.55-31.57-19.46-55.67-28.37",
    style: {
      fill: "#bcb9b9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g298"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#571cf90c-8e76-4a94-ae17-18abe7368f81)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M246.83,182.94a97.83,97.83,0,0,1-50.71-48.15c-20.48-43.21-61.75-125.14-85-131.55C81.27-5,32.3,3.69,25.12,16.29c-7.35,12.86,5.75,92.6-4.81,148.22C8.77,225.39,144.24,234,180.12,242.05c36.55,8.2,136-6.15,127.08-24.54-8.19-16.83-35.06-24.34-60.37-34.57",
    style: {
      fill: "url(#Sfumatura_senza_nome_14)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g314"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#3ba5f0b2-11b1-4a2b-8a37-7d1b0f82f31e)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M207.88,244.41c-10.83,0-20.53-.73-27.76-2.36h0c1,.22,2,.43,3.1.62l.17,0,.94.16.3,0h0c1.5.23,3.07.44,4.71.62a174.6,174.6,0,0,0,18.52.88h0m-27.76-2.36-.1,0h0l.1,0h0m-.11,0-.1,0h0l.08,0h0m-.1,0-.1,0a0,0,0,0,1,0,0h.09m-.11,0C157.37,237,97.59,231.81,57.74,214.3c21.43,9.41,48.63,15.28,72.68,19.45h0l.2,0h0l1,.18h0l.15,0h.05l.16,0h0l.41.07h0l.19,0h0l.2,0h0l.16,0,.09,0h0l.38.07.14,0,.16,0h0l.14,0h.06l.12,0,.12,0h.05l.13,0h.1c18.63,3.14,35,5.31,44.68,7.41h0l.22,0h0l.1,0h0l.09,0h0m-4.67-21.32a899.84,899.84,0,0,1-95.65-5.29c-22.26-7.16-41.54-17-50.6-31a38.32,38.32,0,0,1-5.35-21.51v0a38.78,38.78,0,0,1,.56-4C34.12,106,22.8,31.38,28,13.07a12.25,12.25,0,0,0-2.84,3.22c-7.35,12.87,5.75,92.6-4.81,148.22-.16.9-.3,1.78-.41,2.65.11-.87.25-1.75.41-2.65,10.56-55.62-2.54-135.36,4.81-148.22C30.35,7.11,57.73,0,83.77,0a105.05,105.05,0,0,1,27.39,3.24c23.21,6.42,64.48,88.34,85,131.55a97.83,97.83,0,0,0,50.71,48.15C269.3,192,293,199,303.77,212.18c-3.92-4.8-9.53-8.78-16.18-12.32,0,0,3.35,7.89-53,17.52-10,1.71-31.13,3.28-59.48,3.28m132-3.25v0s0,0,0,0m0-.09,0,0s0,0,0,0m-.05-.09s0,0,0,0,0,0,0,0m-.05-.1,0,0,0,0M307,217s0,0,0,0,0,0,0,0m0-.11h0m-.11-.2v0m-.05-.09v0m-.05-.09s0,0,0,0,0,0,0,0m-.05-.1v0m0-.1h0m-.12-.2h0m-.05-.09v0m-.05-.09a0,0,0,0,1,0,0v0m-.05-.1,0,0,0,0m-.06-.09s0,0,0,0,0,0,0,0m-.06-.1h0m-.11-.2h0m-.06-.09v0m-.05-.09,0,0,0,0m-.06-.09v0m-.06-.09v0m-.18-.29h0m-.05-.09,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-.06-.09,0,0,0,0m-.07-.11h0M57.73,214.3l-.15-.07.15.07m247.6,0,0,0,0,0m-247.77-.06-.15-.06.15.06m247.71,0,0,0,0,0m-247.87,0-.15-.07.15.07m247.81,0,0,0,0,0m-248,0-.62-.28.62.28M305.15,214l0,0,0,0m-.06-.09,0,0,0,0m-.06-.09,0,0,0,0m-248.44-.06-.14-.06.14.06m248.36,0s0,0,0,0,0,0,0,0m-248.53,0-.14-.06.14.06m248.47-.07,0,0,0,0m-248.63,0-.14-.07.14.07m-.15-.07-.47-.21.47.21m248.71,0,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-249.07,0-.13-.06.13.06m249,0,0-.05,0,.05m-249.18,0-.11-.05.11.05m249.12,0-.14-.19.14.19m-249.3,0-.11-.05.11.05m-.16-.07-.12-.06.12.06M55,213l-.39-.18L55,213m249.47,0,0-.05,0,.05m-.06-.08-.05-.05.05.05m-.07-.08,0-.06,0,.06m-249.79,0-.09,0,.09,0m249.73-.05,0-.06,0,.06m-249.9,0-.1,0,.1,0m249.84,0c-.09-.13-.19-.25-.28-.37.09.12.19.24.28.37m-250,0-.08,0,.08,0m-.17-.08-.09,0,.09,0m-.18-.09-.07,0,.07,0m-.23-.11-.08,0,.08,0m250.31-.06-.06-.06.06.06m-250.49,0-.07,0,.07,0m250.43-.05-.06-.07.06.07m-250.6,0-.07,0,.07,0m-.17-.08-.08,0,.08,0m-.18-.09-.06,0,.06,0m-.19-.09,0,0,0,0m-.39-.19,0,0a.05.05,0,0,1,0,0m-.16-.09-.06,0,.06,0M52,211.6l-.05,0,.05,0m-.17-.09,0,0,0,0m-.2-.1h0m-.36-.18,0,0,0,0m-.17-.08-.05,0,.05,0m-.17-.09,0,0,0,0m-.19-.1h0m-.19-.09h0m-.35-.19h0M50,210.6l0,0,0,0m-.17-.09,0,0,0,0m-.19-.1h0m-.7-.37h0m-.17-.09h0m-1-.57h0m-24.2-22a32.63,32.63,0,0,1-3.9-14.83c0-.25,0-.5,0-.75a32.87,32.87,0,0,0,3.91,15.58h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_14-2)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g330"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#649b76a0-2901-4f83-9cb2-3869765e4cc4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M302.72,226.78h0c3.22-2.19,5-4.51,5-6.92a5.06,5.06,0,0,0-.41-2c1.3,3.13-.53,6.14-4.63,8.93",
    style: {
      fill: "url(#Sfumatura_senza_nome_17)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g346"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#45c5051b-2dca-44b1-b5bf-6675dccc8aae)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M207.88,244.41h0c34.23,0,79.81-7.38,94.84-17.63h0c-15,10.25-60.61,17.63-94.84,17.63",
    style: {
      fill: "url(#Sfumatura_senza_nome_16)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g362"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#077d00bc-de9f-4b2a-87c8-25f519663230)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M307.2,217.51s0-.07-.05-.1a.93.93,0,0,1,.05.1m-.06-.12,0-.07,0,.07m-.05-.1,0-.06,0,.06m0-.1,0-.06,0,.06m-.05-.09,0-.06,0,.06m0-.09a.3.3,0,0,1,0-.08.3.3,0,0,0,0,.08m-.05-.09a1.74,1.74,0,0,0-.1-.19,1.14,1.14,0,0,1,.1.19m-.11-.21,0-.07,0,.07m-.05-.1,0-.06a.21.21,0,0,1,0,.06m-.05-.09a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.05-.09a.3.3,0,0,1,0-.08.3.3,0,0,0,0,.08m-.05-.09-.11-.2.11.2m-.11-.2a.41.41,0,0,0-.05-.09.41.41,0,0,1,.05.09m-.06-.11a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.05-.09a.25.25,0,0,1,0-.07.25.25,0,0,0,0,.07m-.06-.09a.25.25,0,0,0,0-.07.16.16,0,0,1,0,.07m-.05-.09a.22.22,0,0,0-.05-.08.22.22,0,0,1,.05.08m-.05-.09-.11-.19.11.19m-.12-.19a.41.41,0,0,0,0-.09.41.41,0,0,1,0,.09m-.06-.11a.43.43,0,0,1,0-.07.43.43,0,0,0,0,.07m-.06-.09,0-.07,0,.07m-.05-.09-.05-.07.05.07m-.06-.09c-.05-.09-.11-.18-.17-.27.06.09.12.18.17.27m-.18-.28,0-.08,0,.08m-.06-.1,0-.06,0,.06m-.06-.09,0-.06,0,.06m-.06-.09,0-.06,0,.06m-.06-.09-.05-.08.05.08m-.05-.08a.47.47,0,0,1-.06-.09l.06.09m-.08-.11,0-.07,0,.07m-.06-.1,0,0,0,0m-.07-.09,0,0,0,0m-.06-.08,0-.06,0,.06m-.05-.09,0-.06,0,.06m-.07-.09-.05-.07.05.07m-.07-.1a.43.43,0,0,1,0-.07l0,.07m-.07-.1a.1.1,0,0,0,0-.05.1.1,0,0,1,0,.05m-.06-.09a.08.08,0,0,0,0,0,.08.08,0,0,1,0,0m-.07-.09,0,0,0,0m-.06-.08,0,0,0,0m-.06-.09,0,0,0,0m-.17-.22v0m-.05-.07,0,0,0,0m-.07-.08,0,0,0,0m-.06-.09,0,0,0,0m-.06-.08h0m-.3-.38h0m-.07-.07h0m-.06-.08h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_17-2)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g378"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#5446b539-a70b-44b1-a077-c51ae3027d06)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g386"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image388",
    width: 98,
    height: 21,
    transform: "translate(75.16 196.09) scale(2.42 2.44)",
    xlinkHref: "data:image/png;base64,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",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g390"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#617010c8-b191-41be-876c-fdd68b6b479d)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M207.88,244.41a174.6,174.6,0,0,1-18.52-.88c-1.64-.18-3.21-.39-4.71-.62h0l-.3-.06-.94-.15-.17,0c-1.08-.19-2.11-.4-3.1-.62a39,39,0,0,0,7.91.59c19.41,0,58.93-6,59.51-6.11,26.06-3.06,51-9,60.2-16.32-1,13.51-58.67,24.2-99.86,24.2m-27.76-2.36-.1,0,.1,0m-.12,0-.08,0,.08,0m-.11,0h0m-.1,0-.09,0,.09,0m-.1,0-.1,0,.1,0m-.1,0-.22,0,.22,0m-.22,0c-9.71-2.1-26.05-4.27-44.68-7.41,18.64,3.15,35,5.31,44.68,7.41m4.42-5.52h0m-.1,0h0m-.1,0h0m-.45-.1h0m-48.45-1.75h0m-.23,0h0m-.17,0-.12,0,.12,0m-.18,0-.14,0,.14,0m-.16,0-.16,0,.16,0m-.3-.05-.38-.07.38.07m-.42-.07-.09,0,.09,0m-.25-.05h0m-.22,0h0m-.19,0h0m-.44-.07h0m-.2,0h0m-.2,0h0m-1.09-.19h0m-.21,0h0M23.53,187.33a32.9,32.9,0,0,1-3.91-15.58,38.21,38.21,0,0,1,.28-4.6c.11-.86.25-1.74.41-2.64,10.56-55.62-2.54-135.35,4.81-148.22A12.25,12.25,0,0,1,28,13.07C22.8,31.38,34.12,106,24.09,158.86a38.78,38.78,0,0,0-.56,4c-.15.77-3.44,17.89,0,24.45",
    style: {
      fill: "url(#Sfumatura_senza_nome_18)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g406"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a5c491f9-cf4a-408e-9240-ab953658a9de)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path420",
    d: "M180,242h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_22)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g422"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#4b6f44e8-4a03-4dc1-8d44-baf37062dce8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g430"
  }, /*#__PURE__*/React.createElement("use", {
    id: "image432",
    transform: "translate(176.41 237.19) scale(2.54 2.54)",
    xlinkHref: "#image",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g434"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#74d85733-2520-4d24-a02b-5243ac2386c4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "M179.91,242h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_22-2)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g450"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#0a711051-4055-4cb3-a148-188fc1990fc6)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g458"
  }, /*#__PURE__*/React.createElement("use", {
    id: "image460",
    transform: "translate(176.41 237.19) scale(2.54 2.54)",
    xlinkHref: "#image",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g462"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#9d1c9e35-9d9b-4f0e-b749-d6f84f53eb3c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path476",
    d: "M179.81,242h0",
    style: {
      fill: "url(#Sfumatura_senza_nome_22-3)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g478"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d0be26d1-5d9e-41dd-8899-d751a1589a47)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g486"
  }, /*#__PURE__*/React.createElement("use", {
    id: "image488",
    transform: "translate(176.41 237.19) scale(2.54 2.54)",
    xlinkHref: "#image",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g490"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#2b4db415-1330-4f42-b1f6-2e3079377095)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g498"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image500",
    width: 30,
    height: 4,
    transform: "translate(178.91 232.18) scale(2.43 2.53)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAFCAYAAAC94zfEAAAACXBIWXMAAASdAAAEnQF8NGuhAAAAZElEQVQoU72RwQ7AIAhDS+L8///dpDuQMFBmdtq7KJRQAnKNk0JBhZIA1IKyRlNE/9T9Ikfv0mZjN/R81rnRvvEM3MwsCBSUhkCpreh+WYFmz4upDzbn87oXygsR4TBWRubEn9xxdy/sP22nrgAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g502"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#5e8340d4-a1a6-4709-b357-52b569c774e0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g510"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image512",
    width: 27,
    height: 24,
    transform: "translate(17.52 160) scale(2.44 2.43)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAZCAYAAAAiwE4nAAAACXBIWXMAAASdAAAEnQF8NGuhAAAA3UlEQVRIS72W0Q6EIAwEp/3/L/YSeg+CiOIJFG5eTLRh221plM+2GSIAaHyaGIICsL8Bid9S7CCi1beWD7VagINdMLxEAWZzpKNv+2HhdKjFLG6WOqlaChw9TCnMrRCabJ1BFpQ5FbzxaKktKln/U1dGuQxDmtRVd7G0NORtU8PMuCbYSykoVtzFKs77+Dg0q1DovNQ9sRXiavPZ1INC3pcAhNNOLXbrHJp7mJLqsr9Cs6BPJqP/7B+A3uTE3vvosLXZ0jOePv4UrFV5MCjaXaH3D+AuaGuHSEYzHeULi7FX7Gd5HxYAAAAASUVORK5CYII=",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g514"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#0dde2283-33c6-4d05-b3a3-b000263f2122)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g522"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image524",
    width: 46,
    height: 12,
    transform: "translate(75.16 210.63) scale(2.42 2.47)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAANCAYAAAA5QzeRAAAACXBIWXMAAASdAAAEnQF8NGuhAAAAo0lEQVRIS9WW2wrDIBAF54j//8l7+qAB28bEQBq28+aywuBeULZNFmyQzrI2VM4yHmVdHIBc8qv0Zvk/+aHL60FaHiZjmVf+YI/YRlJi+YHZQswp32VH6U99AdURqCSY2x1h+JZusQBKe3lHIOnynr0Fe7ctZtKyEM2zmlYC22A/V4WF1mixAHiT3mgv3w9iqAL8phKL0lvuKBzDnQIo09fmKi9d2VH6CI+TCgAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g526"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#7e67c3f3-8822-414f-b7cb-59b49f30e3be)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g534"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image536",
    width: 5,
    height: 3,
    transform: "translate(125.78 229.67) scale(2.53 2.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAACXBIWXMAAAR1AAAEdQEQhIuqAAAAHElEQVQIW2P8////fwY0wIQugFOQhYGBgRFdEABGqAQHUErIIgAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g538"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#69366834-845d-4fe6-b9ed-96b55a50d0c8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M57.74,214.3h0m-.16-.07h0m-.17-.08h0m-.16-.07h0m-.63-.28,0,0,0,0m-.17-.08h0m-.17-.07h0s0,0,0,0m-.16-.08h0m-.48-.21h0a0,0,0,0,1,0,0m-.14-.07,0,0,0,0m-.15-.07-.07,0,.07,0m-.18-.08-.05,0,.05,0m-.17-.08,0,0,0,0m-.43-.2-.06,0,.06,0m-.15-.07-.08,0,.08,0m-.18-.08-.08,0,.08,0m-.16-.08-.09,0,.09,0m-.18-.08-.09-.05.09.05m-.16-.08-.16-.08.16.08m-.24-.12-.1,0,.1,0m-.17-.08-.1-.05.1.05m-.17-.08-.1-.05.1.05M53,212.1l-.1,0,.1,0m-.16-.08-.13-.06.13.06m-.17-.08-.35-.17.35.17m-.39-.19-.12-.07.12.07m-.18-.09L52,211.6l.12.06m-.17-.09-.12-.06.12.06m-.17-.08-.15-.08.15.08m-.17-.09-.34-.17.34.17m-.38-.19-.13-.06.13.06m-.18-.09-.12-.06.12.06m-.17-.08L50.7,211l.14.08m-.16-.09-.17-.08.17.08m-.17-.09-.35-.18.35.18m-.36-.18L50,210.6l.16.08m-.18-.1-.15-.07.15.07m-.18-.09-.16-.08.16.08m-.17-.08-.69-.37.69.37m-.7-.38-.16-.08.16.08m-.17-.09-1-.56,1,.56m-1-.56c-10.89-6-19.48-13.22-24.17-22l0,0c4.68,8.81,13.28,16,24.19,22",
    style: {
      fill: "url(#Sfumatura_senza_nome_22-4)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g554"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#910ba1d9-209e-406f-8a07-d7375f59494f)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g562"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image564",
    width: 47,
    height: 22,
    transform: "translate(20.03 184.06) scale(2.41 2.44)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAXCAYAAABNq8wJAAAACXBIWXMAAASdAAAEnQF8NGuhAAAAxElEQVRYR9WWwQ6EIAxEZ9j//2E3oXvCSlyxZRN2fCdiMOljWpHvbTMAgBHlRezQ121FsnsuAIsvDdVssBdqxQMAXOChFLs79SOZvYsoim2RoXTlV/gcHE5b79yd0Aw0yVS7LSIkoFe2ExJQpheg3c+BWBulE1Cbg0uBbynsCEmkEmhlK6XQC9jzLrVUAsAhhVqH+1YxFBjOgQjhBKyeP6kKKYQFVP/5wgKqpAQU2yglQF5J/G/Iz/9CU8y+9ztUulVn+ABlGVTXVZBFKAAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g566"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f125bffc-9fb8-4b8d-99ef-cf1e5a164dd4)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g574"
  }, /*#__PURE__*/React.createElement("image", {
    id: "image576",
    width: 98,
    height: 36,
    transform: "translate(15.01 160) scale(2.42 2.43)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAAAlCAYAAABWOlfkAAAACXBIWXMAAASdAAAEnQF8NGuhAAACtklEQVRoQ+2aW3KkMAxFJdfsf0+zrJ4PNB+Y2FjyQ0YyJOFUJemmDTK6usJOgv8+H4IOiHg+QAgQAEJ2nOJVMBRjM/gn+5HWOTm0HVOtT7n2CW0E5W1sRAAbACA/iwDSTa3h75/eiFEhtCKMCpCTztl/SuIcI8o0YkAmSECELRDAhkwQhJbkPoTWh1eFQCiFQMAQpoSQwIDxK0AZTYqAAVmxB9zvCUgomfL+namLYSBE/s5SBIlDmFwUXgxxvngW5SmCVMU4TUEhBK/PuZY0y1mUeKwyblQQVphOiGKcqiEKMQJ3w1ohckYFYQiCrLoDnuayCuKIniskIe4mPU/ie2EMc0eFFe2KicHaE+iE8H42zNAS5Ent6ixGpz2NCPFUNIIAwC3t6pQ9KVjTuvnrBwuRQOEVp3XPnu5Im74JVySuT5Aau12rfr1v/ACk7Vy5KaxtCFE824YvMeZdce1hTUSAiMMJP8bPkgtSJhYDAu9X69jrX+kKCyEOJ2gTm49vuWmWkWeHV6sKAHpXXOVqdR/MXiPfg7SuUMvBXNQ+/Knr7AorIUq0LqnNvbqyWkBgLWqQJwkBMOsShTsWtCoxpR729BTCmpFC64/Qczbg8HJWP5VVQmjaldx+d+5oVSmEc4tahV50xXipVanj1RnWezakplKfiufKMoeJkQe2aFH6Sl1La1XVA0GbjTbDzpjhTlfMxO4+N5ypimExkTtdoYutGetHEF41GbHvj2UwR7M4X/5Fwy6GYln763HM1euMB/GK8SDi3zMMlk4vl3mdocWxcJMYW2PUyxKqzqjtmdJ/fveZ2QVb4RLbuWBd25RuF2yLLjZl3xOqSxjAxNiyipJd4FBx3xQC22wMO8MyqDeaFlVru5p2bEUSQ7FK0E5UkxwLdC2qz1e3KHNEZPMb1QiuTtRLnf9HhdeKwr8fIQAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g578"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a5d47298-7128-40e0-8af6-19af1d179bfa)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path594",
    d: "M307.2,217.51c-8.19-16.83-35.06-24.34-60.37-34.58a97.72,97.72,0,0,1-50.7-48.14c-20.49-43.21-61.76-125.14-85-131.55-22-6.07-54.18-3-72.6,4.08C57.4,1.89,85,0,104.56,5.44c23.21,6.42,64.48,88.34,85,131.55a97.72,97.72,0,0,0,50.7,48.14c25.31,10.24,52.18,17.75,60.37,34.58,2.57,5.28-2.35,16.56-84.62,24.7,92.88-1.78,94.25-20.66,91.22-26.9",
    style: {
      fill: "url(#Sfumatura_senza_nome_23)"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChairWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chair-white.3fde99dd96f47597c55bdf7819d09fec.svg";